import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import ContactPage from './ContactPage';

const AboutPage = () => {
  const team = [
    {
      name: 'John Smith',
      position: 'Chief Executive Officer',
      bio: 'With over 20 years of experience in enterprise software, John leads our company vision and strategy.',
      image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=300&q=80'
    },
    {
      name: 'Sarah Johnson',
      position: 'Chief Technology Officer',
      bio: 'Sarah drives our technological innovation and oversees the development of all our products.',
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=300&q=80'
    },
    {
      name: 'Michael Chen',
      position: 'Chief Operating Officer',
      bio: 'Michael ensures operational excellence and efficient delivery of our solutions to clients worldwide.',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=300&q=80'
    },
    {
      name: 'Emily Rodriguez',
      position: 'Chief Marketing Officer',
      bio: 'Emily leads our marketing initiatives and builds our brand presence in the global market.',
      image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=300&q=80'
    }
  ];

  return (
    <>
    
      <div className="bg-light py-5">
        <Container>
          <h1 className="text-center fw-bold mb-5">About VCRP</h1>
          
          <Row className="align-items-center mb-5">
            <Col lg={6} className="mb-4 mb-lg-0">
              <h2 className="fw-bold mb-4">Our Mission</h2>
              <p className="lead">To empower businesses worldwide with innovative, reliable, and user-friendly enterprise solutions that drive growth and efficiency.</p>
              <p>At VCRP, we believe that every business, regardless of size or industry, deserves access to powerful tools that can streamline operations and unlock new potential. Our mission is to democratize enterprise technology by providing intuitive, scalable, and affordable solutions.</p>
              <p>Founded in 2024, we've grown from a small team of passionate developers to a global company serving thousands of businesses across 3+ countries.</p>
            </Col>
            <Col lg={6}>
              <img
                src="https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=400&q=80"
                alt="Company Office"
                className="img-fluid rounded shadow"
              />
            </Col>
          </Row>
          
          {/* <h2 className="text-center fw-bold mb-5">Our Leadership Team</h2>
          <Row xs={1} md={2} lg={4} className="g-4 mb-5">
            {team.map((member, idx) => (
              <Col key={idx}>
                <Card className="border-0 h-100 shadow-sm">
                  <Card.Img variant="top" src={member.image} />
                  <Card.Body className="text-center">
                    <Card.Title className="fw-bold">{member.name}</Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">{member.position}</Card.Subtitle>
                    <Card.Text>{member.bio}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row> */}
          
          <Row className="justify-content-center">
            <Col md={10} lg={8}>
              <div className="text-center">
                <h2 className="fw-bold mb-4">Our Values</h2>
                <Row xs={1} md={3} className="g-4">
                  <Col>
                    <div className="py-3">
                      <div className="fs-1 text-primary mb-3">🔍</div>
                      <h5 className="fw-bold">Innovation</h5>
                      <p>We continuously push boundaries to develop cutting-edge solutions.</p>
                    </div>
                  </Col>
                  <Col>
                    <div className="py-3">
                      <div className="fs-1 text-primary mb-3">🤝</div>
                      <h5 className="fw-bold">Customer Success</h5>
                      <p>Your success is our success. We're committed to helping you achieve your goals.</p>
                    </div>
                  </Col>
                  <Col>
                    <div className="py-3">
                      <div className="fs-1 text-primary mb-3">🛡️</div>
                      <h5 className="fw-bold">Reliability</h5>
                      <p>We deliver dependable solutions you can count on, day after day.</p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <ContactPage/>
    </>
  );
};

export default AboutPage;
